<div
  class="group relative z-[1] overflow-hidden rounded-2xl bg-neutral-50 shadow-md"
  [ngClass]="configurableClasses()"
>
  <div class="flex flex-wrap bg-neutral-100">
    @if (showCheckbox()) {
      <div
        class="w-0 shrink-0 overflow-hidden transition-all duration-150 group-hover:w-12"
        [class.w-12]="checkboxSelected()"
      ></div>
    }
    <div class="flex flex-1 flex-wrap justify-between">
      <div class="flex items-center gap-2 px-4">
        <ng-content select="[header-indicators]" />
      </div>
      <div class="flex">
        <ng-content select="[header-actions]" />
      </div>
    </div>
  </div>
  <div class="flex items-stretch">
    @if (showCheckbox()) {
      <div
        class="flex w-0 shrink-0 items-center justify-center overflow-hidden transition-all duration-150 group-hover:w-12"
        [class.w-12]="checkboxSelected()"
      >
        <ng-content select="[leading-checkbox]" />
      </div>
    }
    <div class="min-w-0 flex-1">
      <div class="grid w-full grid-cols-12 gap-4 px-4 py-2">
        <ng-content />
      </div>
    </div>
  </div>
</div>
